import { createUseStyles } from 'react-jss'

const useStyles = createUseStyles({
  container: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: 10,
    marginTop: 16
  },
  leadFormField: {
    flex: 1,
    marginTop: [0, '!important']
  },
  refreshLeadGenFormsButton: {
    display: 'block',
    marginLeft: 'auto'
  }
})

export default useStyles
